module.exports = new __parcel__URL__("hud_shop_button.5a581be9.png").toString();